import { useRef, useState, useEffect } from "react";
// import { useLocalTranslation } from '@/hooks/useLocalTranslation';

import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { isValidImageDataURI, convertImageToBase64UsingCanvas } from "@/utils"
// import WhiteCrop from "@/assets/icons/whiteCrop.png";

export default function ImageCropper(props: any) {
    // const { common } = useLocalTranslation();

    const cropperRef: any = useRef(null);
    // const [croppedImage, setCroppedImage] = useState<string | null>(null);
    const [image, setImage] = useState<any>(null);
    const [imageVersion, setImageVersion] = useState(0);

    // const cropImage = () => {
    //     const cropper = cropperRef.current?.cropper;
    //     const croppedDataUrl = cropper?.getCroppedCanvas().toDataURL("image/png");
    //     // props.setImgToParentCom(croppedDataUrl)
    //     // setCroppedImage(croppedDataUrl || null);
    // };

    useEffect(() => {
        if (props.ogImage) {
            handleUpdateOgImg(props.ogImage)
        }
        // setCroppedImage(null)
    }, [props.ogImage])

    const handleUpdateOgImg = async (ogImage: any) => {
        let useThisImg = ogImage
        const isValidImageDataURI_ = isValidImageDataURI(useThisImg)
        if (!isValidImageDataURI_) {
            useThisImg = await convertImageToBase64UsingCanvas(useThisImg)
        }
        setImage(useThisImg)
        setImageVersion((v) => v + 1);
    }

    const handleCrop_ = () => {
        const cropper = cropperRef.current?.cropper;
        const croppedDataUrl = cropper?.getCroppedCanvas().toDataURL();
        if (croppedDataUrl) {
            props.handleCrop(croppedDataUrl)
        }
    }


    return (
        <div className="imageEditer">
            {!image &&
                <div className='animate-pulse flex items-end loader'>
                    <div
                        style={{
                            height: props.loaderHeight ? props.loaderHeight : 300,
                            width: props.loaderWidth ? props.loaderWidth : 300
                        }}
                        className="bg-gray-400 rounded"></div>
                    <div className="loaderBtn h-[25px] w-[25px] ml-[8px] bg-gray-400 rounded-[50%] "></div>
                    <div className="loaderBtn h-[25px] w-[25px] ml-[8px] bg-gray-400 rounded-[50%] "></div>
                </div>
            }
            {image &&
                <div className="imageEditer1">

                    <Cropper
                        key={imageVersion}
                        src={image}
                        style={{
                            maxHeight: props.maxHeight ? props.maxHeight : 350,
                            maxWidth: props.maxWidth ? props.maxWidth : 350,
                            // width: '100%',
                            // height: '100%',
                        }}
                        initialAspectRatio={1}
                        guides={true}
                        ref={cropperRef}
                        viewMode={1}
                        background={false}
                        responsive={true}
                        autoCropArea={1}
                        checkOrientation={false}
                        crop={() => {
                            handleCrop_()
                        }}
                    />


                    {/* <div className="flex controlCon">
                        <button
                            className="controlCon1 flex bg-[#1573FE] text-white rounded-[100px] items-center text-[12px] h-[34px] w-[105px] justify-center mr-[5px]"
                            onClick={cropImage}
                        >
                            <img
                                className="w-[18px] mr-[5px] cursor-pointer"
                                src={WhiteCrop} alt="WhiteCrop" />
                            {common.statusText.saveCropBtn}
                        </button>
                    </div> */}

                    {/* {croppedImage && (
                        <div className="mt-6">
                            <h3 className="text-lg font-semibold mb-2">Cropped Image:</h3>
                            <img src={croppedImage} alt="Cropped" className="rounded border" />
                        </div>
                    )} */}
                </div>
            }

        </div>
    );
}
